<template>
    <v-card class="mx-3">
      <v-card-text class="pa-0">
        <base-data-grid
          :ref="grid.key"
          :gridKey="grid.key"
          :dataSource="grid.dataSource"
          :columns="grid.columns"
          :actions="grid.actions"
          :exportFileName="title"
          :isStateStoringEnabled="true"
          @on-row-action-click="gridRowClick"
          @on-add-click="add"
          :allowGrouping="false"
          :allowFilterPanel="false"
          data-testid="role-grid"
          :title="title"
        />
      </v-card-text>
    </v-card>
</template>

<script>
import RoleService from '@/services/RoleService';
import Utils from '@/ecm/common/Utils';
import Role from '@/views/administration/role/Role.vue';
export default {
    components: {
        Role
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.childComponents = [Role.name];
            if (!vm.childComponents.includes(from.name)) {
                vm.gridInstance.saveState(null);
            }
        });
    },
    beforeRouteLeave(to, from, next) {
        this.$nextTick(() => {
            if (this.childComponents.includes(to.name)) {
                const gridState = this.gridInstance.loadState();
                this.gridInstance.saveState(gridState);
            }
            next();
        });
    },

    data() {
        return {
            title: this.$t('Roles'),
            grid: {
                key: 'roleGrid',
                dataSource: RoleService.getGrid(),
                columns: [
                    {
                        field: 'Name',
                        caption: this.$t('Name'),
                        type: 'string',
                    },
                    {
                        field: 'Description',
                        caption: this.$t('Description'),
                        type: 'string',
                    },
                ],
                actions: [
                    {
                        name: 'edit',
                        icon: 'mdi-pencil',
                        tooltip: this.$t('Edit'),
                        color: 'primary',
                    },
                    {
                        name: 'delete',
                        icon: 'mdi-delete',
                        tooltip: this.$t('Delete'),
                        color: 'red',
                    },
                ],
            },
            childComponents: [],
        };
    },
    computed: {
        gridInstance() {
            return this.$refs[this.grid.key];
        },
    },
    methods: {
        gridRowClick(action) {
            if (action.name === 'edit') {
                this.edit(action.data.Id);
            }
            if (action.name === 'delete') {
                this.delete(action.data.Id);
            }
        },
        edit(id) {
            this.$router.push(`/administration/roles/${id}`);
        },
        delete(id) {
            this.$confirm(this.$t('ItemDeleteConfirmation'), {
                title: this.$t('Delete'),
                icon: 'mdi-alert',
                color: 'red',
                buttonTrueText: this.$t('Delete'),
                buttonFalseText: this.$t('Cancel'),
            }).then((res) => {
                if (res == 1) {
                    RoleService.delete(id).then((result) => {
                        this.gridInstance.refresh();
                        Utils.toast.success(this.$t('Role') + ' ' + this.$t('DeletedSuccessfully'));
                    });
                }
            });
        },
        add() {
            this.$router.push('/administration/roles/0');
        },
        onItemSaved() {
            this.gridInstance.refresh();
        },
    },
};
</script>